import React from 'react';

const money = cents => (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const dates = values => values?.length ? values.map(value => value.slice(0, 10).split('-').reverse().join('/')).join(', ') : 'Nenhum';

export default function InvoiceAutomaticBenefits({ benefits }) {
  return <>{['VT', 'VA'].filter(benefit => benefits?.[benefit]).map(benefit => {
    const calculation = benefits[benefit];
    const valid = [calculation.dailyCents, calculation.eligibleDays, calculation.totalCents].every(value => Number.isSafeInteger(value) && value >= 0);
    const location = calculation.calendar?.location;
    return <section key={benefit} className="invoice-calculation-details__registered">
      <h4>{benefit} automático</h4>
      {valid ? <>
        <p><strong>{money(calculation.dailyCents)} × {calculation.eligibleDays} dias = {money(calculation.totalCents)}</strong></p>
        <p className="invoice-billing-controls__footnote">{calculation.dayMode === 'COURSE_DAYS' ? 'Somente dias de curso' : calculation.dayMode === 'WEEKDAYS_SATURDAY' ? 'Dias úteis + sábado' : 'Dias úteis'}{location ? ` • ${location.city} / ${location.state}` : ''}</p>
        <details className="invoice-calculation-details__extra"><summary>Ver datas do cálculo de {benefit}</summary>
          <p>Datas elegíveis: {dates(calculation.eligibleDates)}</p>
          <p>Férias excluídas ({calculation.vacationDays}): {dates(calculation.vacationDates)}</p>
          <p>Feriados excluídos ({calculation.holidayDays}): {dates(calculation.holidayDates)}</p>
        </details>
      </> : <p role="alert">Cálculo automático de {benefit} indisponível nesta fatura.</p>}
    </section>;
  })}</>;
}
